// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"KIDPromo_noScrolling__dlpAr","desktop":"KIDPromo_desktop__eCsbG","mobile":"KIDPromo_mobile___J69t"};